import React from 'react';
import PropTypes from 'prop-types';
import './MenuItem.css';

const MenuItem = props => {
  const { classes, openContent, content, title } = props;
  return (
    <li>
      <button
        className={classes}
        onClick={() => openContent(content)}
        type='button'
      >
        {title}
      </button>
    </li>
  );
};

MenuItem.propTypes = {
  classes: PropTypes.string,
  content: PropTypes.string,
  openContent: PropTypes.func,
  title: PropTypes.string,
};

MenuItem.defaultProps = {
  classes: '',
  content: '',
  openContent: () => {},
  title: '',
};
export default MenuItem;
